import { Component, inject } from '@angular/core';
import { PurchaseOrderService } from '../proxy/controlling/controllers';
import { ListService } from '@abp/ng.core';
import {
  ConfirmationService,
} from '@abp/ng.theme.shared';
import {
  PurchaseOrderCreateDto,
  PurchaseOrderDto,
  PurchaseOrderExcelDownloadDto,
  PurchaseOrderUpdateDto,
} from '../proxy/controlling/dtos/purchase-order';
import { PURCHASEORDER_CONFIG, PURCHASEORDER_FIELDS } from './purchase-order.config';
import { BaseHierarchicalCrudComponent, GenericForm, ZnHierarchicalViewComponent } from '@zendra/shared';
import { CommonModule } from '@angular/common';
import { VendorService } from 'orchestrator';

@Component({
  selector: 'app-purchase-order',
  imports: [
    CommonModule,
    GenericForm,
    ZnHierarchicalViewComponent,
  ],
  providers: [ListService, PurchaseOrderService, ConfirmationService, VendorService],
  templateUrl: './purchase-order.html',
  styleUrl: './purchase-order.scss',
})
export class PurchaseOrder extends BaseHierarchicalCrudComponent<
  PurchaseOrderDto,
  PurchaseOrderCreateDto,
  PurchaseOrderUpdateDto,
  PurchaseOrderExcelDownloadDto
> {
  service = inject(PurchaseOrderService);
  config = PURCHASEORDER_CONFIG;
  fields = PURCHASEORDER_FIELDS;

  protected prepareUpdateDto(data: any, selected: PurchaseOrderDto): PurchaseOrderUpdateDto {
    return {
      number: data.number,
      purchasingOrganization: data.purchasingOrganization,
      purchasingGroup: data.purchasingGroup,
      purchaseDate: data.purchaseDate,
      purchaseOrderTypeId: data.purchaseOrderTypeId,
      vendorId: data.vendorId,
      companyCodeId: data.companyCodeId,
      currencyId: data.currencyId,
      concurrencyStamp: selected.concurrencyStamp,
    };
  }

  protected getEntityName(): string {
    return 'PurchaseOrder';
  }
}
